import { ItemImage } from "@coworker/apprestructured/src/shared/components/item-cards/ItemImage/ItemImage";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemDescription } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDescription/ItemDescription";
import { ItemStockAndEds } from "@coworker/apprestructured/src/shared/components/item-cards/ItemStockAndEds/ItemStockAndEds";
import { ItemDelivery } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDelivery/ItemDelivery";
import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import styles from "../../../styles/common-styles.module.css";
import { ItemNoWithCopy } from "../ItemNoWithCopy/ItemNoWithCopy";

interface ItemCardWithCopyNoProps {
  item: Item;
}

export const ItemCardWithCopyNo = ({ item }: ItemCardWithCopyNoProps) => {
  return (
    <ItemCard>
      <div className={styles["item-card-root-row"]}>
        <ItemImage imageUrl={item.smallImageUrl || item.imageUrl || ""} />
        <div className={styles["item-card-root-column"]}>
          <ItemName name={item.name} />
          <ItemNoWithCopy itemNo={item.noFormatted} />
          <ItemDescription description={item.description || ""} />
          <ItemStockAndEds itemNo={item.no} itemType={item.type} />
          <ItemDelivery itemNo={item.no} />
        </div>
      </div>
    </ItemCard>
  );
};
